import moment from 'moment'
import { getWeekDay } from './WeekDaysEnum'

export const ValidDays = [
  {
    id: 0,
    day: 'Segunda-Feira',
    date: '2019-11-18',
    isValid: false,
    open: new Date('2019-01-01T09:00:00'),
    close: new Date('2019-01-01T18:00:00')
  },
  {
    id: 1,
    day: 'Terça-Feira',
    date: '2019-11-19',
    isValid: false,
    open: new Date('2019-01-01T09:00:00'),
    close: new Date('2019-01-01T18:00:00')
  },
  {
    id: 2,
    day: 'Quarta-Feira',
    date: '2019-11-20',
    isValid: false,
    open: new Date('2019-01-01T09:00:00'),
    close: new Date('2019-01-01T18:00:00')
  },
  {
    id: 3,
    day: 'Quinta-Feira',
    date: '2019-11-21',
    isValid: false,
    open: new Date('2019-01-01T09:00:00'),
    close: new Date('2019-01-01T18:00:00')
  },
  {
    id: 4,
    day: 'Sexta-Feira',
    date: '2019-11-22',
    isValid: false,
    open: new Date('2019-01-01T09:00:00'),
    close: new Date('2019-01-01T18:00:00')
  },
  {
    id: 5,
    day: 'Sábado',
    date: '2019-11-23',
    isValid: false,
    open: new Date('2019-01-01T09:00:00'),
    close: new Date('2019-01-01T18:00:00')
  },
  {
    id: 6,
    day: 'Domingo',
    date: '2019-11-24',
    isValid: false,
    open: new Date('2019-01-01T09:00:00'),
    close: new Date('2019-01-01T18:00:00')
  }
]

export const DateListHelper = list => {
  return list
    .filter(day => {
      return day.isValid
    })
    .map(day => {
      const { date } = day
      const startTime = moment(day.open).format('HH:mm')
      const endTime = moment(day.close).format('HH:mm')

      return {
        startTime,
        endTime,
        date
      }
    })
}

export const DateListHelperInvert = list => {
  if (list) {
    let listDay = [...ValidDays]
    const newArr = list.map(day => {
      const { date, situation, id } = day
      const open = new Date(`2019-01-01T${day.startTime}`)
      const close = new Date(`2019-01-01T${day.endTime}`)

      return {
        id,
        date,
        open,
        close,
        isValid: situation,
        day: getWeekDay(date)
      }
    })

    if (newArr.length < 7) {
      newArr.forEach(item => {
        if (item.day === 'Segunda-Feira') listDay[0] = item
        if (item.day === 'Terça-Feira') listDay[1] = item
        if (item.day === 'Quarta-Feira') listDay[2] = item
        if (item.day === 'Quinta-Feira') listDay[3] = item
        if (item.day === 'Sexta-Feira') listDay[4] = item
        if (item.day === 'Sábado') listDay[5] = item
        if (item.day === 'Domingo') listDay[6] = item
      })
    } else {
      listDay = [...newArr]
    }

    return listDay
  }

  return []
}
